import Vue from 'www/vue_components'
import I18NextVue from 'i18next-vue'
import vuetify from 'www/modules/vuetify-plugin'
import { initI18n, dispatchCustomEventGlobally } from 'www/utils'
import VideoCard from 'www/vue_components/common/VideoCard/VideoCard.vue'
import initTooltips from 'www/doctors.blocks/common/tippy-tooltip/tippy-tooltip'

const mountElements = [...document.querySelectorAll('.video-card-vue')]

const init = async () => {
  const { i18next } = await initI18n({ bundle: 'vue_components/common/VideoCard' })

  Vue.use(I18NextVue, { i18next })

  if (mountElements.length) {
    mountElements.forEach(node => {
      const VueInstance = new Vue({
        vuetify,
        components: { VideoCard },
      })

      VueInstance.$mount(node)
    })

    document.addEventListener('click', event => {
      try {
        if (!event.target) {
          return
        }

        const desktopButton = event.target.closest('.b-doctor-details__video-play')
        const mobileButton = event.target.closest('.b-doctor-info-card__video-play')

        if (desktopButton || mobileButton) {
          dispatchCustomEventGlobally('click-video-preview-image')
        }
      } catch {} // eslint-disable-line
    })

    if (!window.MOBILE_VERSION) {
      initTooltips()
    }
  }
}

init()
